enum API {
	COMMANDS = '/api/commands',
	COMMANDS_BY_ID = '/api/commands/'
}

export default API;
